import { useEffect, useMemo, useState } from "react";
import api from "api/axiosInstance";
import Container from "../../layout/Container/Container";
import s from "./VideoTeaser.module.scss";

type ClinicInfoRow = { id: number; name: string; detail: string };

const KEY_TITLE = "home.videoTeaser.title";
const KEY_LEAD = "home.videoTeaser.lead";
const KEY_VIDEO = "home.videoTeaser.videoId";

export default function VideoTeaser() {
  const [rows, setRows] = useState<ClinicInfoRow[]>([]);
  const [videoError, setVideoError] = useState(false);

  const byKey = useMemo(() => {
    const m = new Map<string, string>();
    rows.forEach((r) => m.set(r.name, r.detail));
    return m;
  }, [rows]);

  const title = byKey.get(KEY_TITLE) || "Короткое видео о клинике";
  const lead =
    byKey.get(KEY_LEAD) ||
    "Здесь будет видео‑визитка. Пока используем заглушку — позже заменим на реальный ролик.";
  const videoId = byKey.get(KEY_VIDEO) || "";

  useEffect(() => {
    let mounted = true;
    api
      .get<unknown>("/clinic-info")
      .then((res) => {
        if (mounted) {
          setRows(Array.isArray(res.data) ? (res.data as ClinicInfoRow[]) : []);
        }
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  const hasVideo = Boolean(videoId) && !videoError;

  return (
    <div className={s.section}>
      <Container>
        <div className={s.panel}>
          <div className={s.wrap}>
            <div className={s.videoBox} aria-label={hasVideo ? "Видео" : "Видео-заглушка"}>
              {hasVideo ? (
                <video
                  className={s.video}
                  controls
                  autoPlay
		  muted
                  playsInline
                  preload="metadata"
                  src={`/videos/${videoId}`}
                  onError={() => setVideoError(true)}
                  controlsList="nodownload"
                  disablePictureInPicture
                />
              ) : (
                <>
                  <div className={s.play} />
                  <div className={s.note}>Видео появится позже</div>
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
